import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tether from 'react-tether'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link } from 'react-router-dom'
import classNames from 'classnames'


import { ACCOUNT_BILLING_PATH, subscriptionPlans } from 'config'
import { getSubscriptionPlan } from 'modules/subscriptions'
import { getCounterValue } from 'modules/counter'


class UsageBar extends Component {
  static propTypes = {
    counter: PropTypes.number,
    subscriptionPlan: PropTypes.string,
  }

  static defaultProps = {
    counter: 0,
    subscriptionPlan: 'basic',
  }

  state = { isOpen: false }

  showTooltip = () => {
    this.setState({ isOpen: true })
  }

  hideTooltip = () => {
    this.setState({ isOpen: false })
  }

  render() {
    const { counter, subscriptionPlan } = this.props;
    const plan = subscriptionPlans[subscriptionPlan];

    if (typeof plan === 'undefined') {
      return null
    }

    const progress = plan.limit ? counter / parseInt(plan.limit.replace(/,/g, ''), 10) : 0;
    const progressValue = Math.round(progress * 100);

    return (
      <Tether attachment="bottom center" constraints={ [{
        to: 'scrollParent',
        attachment: 'together',
      }] }>
        <div
          className="progress form-control"
          onMouseOver={ this.showTooltip }
          onMouseOut={ this.hideTooltip }>
          <div
            className={ classNames('progress-bar bg-primary', {
              'text-gray-dark': (progressValue < 4),
            }) }
            role="progressbar"
            aria-valuenow={ progress } aria-valuemin="0" aria-valuemax="1"
            style={ { width: `${progressValue}%` } }>
            {progress >= 1 ?
              <Link to={ACCOUNT_BILLING_PATH}>100% -  Upgrade!</Link> :
              <span>{`${progressValue}%`}</span>
            }
          </div>
        </div>
        { this.state.isOpen && (
          <div
            className="tooltip tooltip-top show"
            style={ { position: 'relative', width: '200px' } }>
            <div className="tooltip-inner text-sm text">
              Usage this month:<br />
              { counter.toLocaleString() } pages out of { plan.limit }
            </div>
          </div>
        ) }
      </Tether>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  subscriptionPlan: getSubscriptionPlan,
  counter: getCounterValue,
});

export default connect(mapStateToProps)(UsageBar)



// WEBPACK FOOTER //
// ./src/components/sites/usage-bar.js